module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-Regular-70804b1f9f4eeb4adb17f0167a458920.ttf";